/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ConductorLicenseRouteImport } from './routes/conductor-license'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CustomerStoriesRouteImport } from './routes/customer-stories'
import { Route as DbosConductorRouteImport } from './routes/dbos-conductor'
import { Route as DbosPricingRouteImport } from './routes/dbos-pricing'
import { Route as DbosTransactRouteImport } from './routes/dbos-transact'
import { Route as OpnPledgeRouteImport } from './routes/opn-pledge'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as StartupRouteImport } from './routes/startup'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies/$slug'
import { Route as CompareDbosVsTemporalRouteImport } from './routes/compare/dbos-vs-temporal'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as JobsKeepMeInMindRouteImport } from './routes/jobs/keep-me-in-mind'
import { Route as PartnershipsSlugRouteImport } from './routes/partnerships/$slug'
import { Route as WebcastSlugRouteImport } from './routes/webcast/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ConductorLicenseRoute = ConductorLicenseRouteImport.update({
  id: '/conductor-license',
  path: '/conductor-license',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerStoriesRoute = CustomerStoriesRouteImport.update({
  id: '/customer-stories',
  path: '/customer-stories',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosConductorRoute = DbosConductorRouteImport.update({
  id: '/dbos-conductor',
  path: '/dbos-conductor',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosPricingRoute = DbosPricingRouteImport.update({
  id: '/dbos-pricing',
  path: '/dbos-pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosTransactRoute = DbosTransactRouteImport.update({
  id: '/dbos-transact',
  path: '/dbos-transact',
  getParentRoute: () => rootRouteImport,
} as any)
const OpnPledgeRoute = OpnPledgeRouteImport.update({
  id: '/opn-pledge',
  path: '/opn-pledge',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const StartupRoute = StartupRouteImport.update({
  id: '/startup',
  path: '/startup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosRoute = VideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
  id: '/case-studies/$slug',
  path: '/case-studies/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareDbosVsTemporalRoute = CompareDbosVsTemporalRouteImport.update({
  id: '/compare/dbos-vs-temporal',
  path: '/compare/dbos-vs-temporal',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsKeepMeInMindRoute = JobsKeepMeInMindRouteImport.update({
  id: '/jobs/keep-me-in-mind',
  path: '/jobs/keep-me-in-mind',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnershipsSlugRoute = PartnershipsSlugRouteImport.update({
  id: '/partnerships/$slug',
  path: '/partnerships/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const WebcastSlugRoute = WebcastSlugRouteImport.update({
  id: '/webcast/$slug',
  path: '/webcast/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/videos': typeof VideosRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/videos': typeof VideosRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog': typeof BlogIndexRoute
  '/jobs': typeof JobsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/videos': typeof VideosRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about'
    | '/conductor-license'
    | '/contact'
    | '/customer-stories'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/startup'
    | '/terms-of-service'
    | '/videos'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/webcast/$slug'
    | '/blog/'
    | '/jobs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about'
    | '/conductor-license'
    | '/contact'
    | '/customer-stories'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/startup'
    | '/terms-of-service'
    | '/videos'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/webcast/$slug'
    | '/blog'
    | '/jobs'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about'
    | '/conductor-license'
    | '/contact'
    | '/customer-stories'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/startup'
    | '/terms-of-service'
    | '/videos'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/webcast/$slug'
    | '/blog/'
    | '/jobs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  ConductorLicenseRoute: typeof ConductorLicenseRoute
  ContactRoute: typeof ContactRoute
  CustomerStoriesRoute: typeof CustomerStoriesRoute
  DbosConductorRoute: typeof DbosConductorRoute
  DbosPricingRoute: typeof DbosPricingRoute
  DbosTransactRoute: typeof DbosTransactRoute
  OpnPledgeRoute: typeof OpnPledgeRoute
  PartnersRoute: typeof PartnersRoute
  PrivacyRoute: typeof PrivacyRoute
  StartupRoute: typeof StartupRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  VideosRoute: typeof VideosRoute
  BlogSlugRoute: typeof BlogSlugRoute
  CaseStudiesSlugRoute: typeof CaseStudiesSlugRoute
  CompareDbosVsTemporalRoute: typeof CompareDbosVsTemporalRoute
  JobsKeepMeInMindRoute: typeof JobsKeepMeInMindRoute
  PartnershipsSlugRoute: typeof PartnershipsSlugRoute
  WebcastSlugRoute: typeof WebcastSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conductor-license': {
      id: '/conductor-license'
      path: '/conductor-license'
      fullPath: '/conductor-license'
      preLoaderRoute: typeof ConductorLicenseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-stories': {
      id: '/customer-stories'
      path: '/customer-stories'
      fullPath: '/customer-stories'
      preLoaderRoute: typeof CustomerStoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-conductor': {
      id: '/dbos-conductor'
      path: '/dbos-conductor'
      fullPath: '/dbos-conductor'
      preLoaderRoute: typeof DbosConductorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-pricing': {
      id: '/dbos-pricing'
      path: '/dbos-pricing'
      fullPath: '/dbos-pricing'
      preLoaderRoute: typeof DbosPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-transact': {
      id: '/dbos-transact'
      path: '/dbos-transact'
      fullPath: '/dbos-transact'
      preLoaderRoute: typeof DbosTransactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opn-pledge': {
      id: '/opn-pledge'
      path: '/opn-pledge'
      fullPath: '/opn-pledge'
      preLoaderRoute: typeof OpnPledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/startup': {
      id: '/startup'
      path: '/startup'
      fullPath: '/startup'
      preLoaderRoute: typeof StartupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos': {
      id: '/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/case-studies/$slug': {
      id: '/case-studies/$slug'
      path: '/case-studies/$slug'
      fullPath: '/case-studies/$slug'
      preLoaderRoute: typeof CaseStudiesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/dbos-vs-temporal': {
      id: '/compare/dbos-vs-temporal'
      path: '/compare/dbos-vs-temporal'
      fullPath: '/compare/dbos-vs-temporal'
      preLoaderRoute: typeof CompareDbosVsTemporalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/keep-me-in-mind': {
      id: '/jobs/keep-me-in-mind'
      path: '/jobs/keep-me-in-mind'
      fullPath: '/jobs/keep-me-in-mind'
      preLoaderRoute: typeof JobsKeepMeInMindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partnerships/$slug': {
      id: '/partnerships/$slug'
      path: '/partnerships/$slug'
      fullPath: '/partnerships/$slug'
      preLoaderRoute: typeof PartnershipsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webcast/$slug': {
      id: '/webcast/$slug'
      path: '/webcast/$slug'
      fullPath: '/webcast/$slug'
      preLoaderRoute: typeof WebcastSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  ConductorLicenseRoute: ConductorLicenseRoute,
  ContactRoute: ContactRoute,
  CustomerStoriesRoute: CustomerStoriesRoute,
  DbosConductorRoute: DbosConductorRoute,
  DbosPricingRoute: DbosPricingRoute,
  DbosTransactRoute: DbosTransactRoute,
  OpnPledgeRoute: OpnPledgeRoute,
  PartnersRoute: PartnersRoute,
  PrivacyRoute: PrivacyRoute,
  StartupRoute: StartupRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  VideosRoute: VideosRoute,
  BlogSlugRoute: BlogSlugRoute,
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,
  CompareDbosVsTemporalRoute: CompareDbosVsTemporalRoute,
  JobsKeepMeInMindRoute: JobsKeepMeInMindRoute,
  PartnershipsSlugRoute: PartnershipsSlugRoute,
  WebcastSlugRoute: WebcastSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
